import React, { FC } from 'react';
import { PropsWithChildrenOnly } from '../../types/propsWithChildrenOnly';

const TabsContent: FC<PropsWithChildrenOnly> = ({ children }) => {
  return <div className="tab-content">{children}</div>;
};

export default TabsContent;
